module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/content/content-layout.component.scss
// module id = ./src/app/layouts/content/content-layout.component.scss
// module chunks = main